import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { useI18n } from 'vue-i18n';
import MapMarkerTooltip from './MapMarkerTooltip.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TransportMapMarkerTooltip',
    props: {
        transport: {
            type: Object,
            required: true,
        },
        isVisible: {
            type: Boolean,
            required: true,
        },
    },
    setup: function (__props) {
        var t = useI18n({ useScope: 'global' }).t;
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(MapMarkerTooltip, {
                text: _unref(t)("transport.status.".concat(__props.transport.status)),
                position: __props.transport.coordinates,
                isVisible: __props.isVisible
            }, null, 8 /* PROPS */, ["text", "position", "isVisible"]));
        };
    }
});
